import { APPROVAL_BRANCHES, isApprovalStep } from '@/utils/automationBuilder';

export function resolveBranchLabel({ sourceStep, branchID, defaultLabel, branches }) {
    if (!sourceStep) return defaultLabel || null;
    // REQUEST_APPROVAL steps branch on a fixed outcome list, not config.branches.
    if (isApprovalStep(sourceStep)) {
        return APPROVAL_BRANCHES.find(b => b.id === branchID)?.label || defaultLabel || null;
    }
    const stepBranches = branches || sourceStep.config?.branches || [];
    if (branchID === 'default') {
        const defaultBranch = stepBranches.find(b => b.isDefault) || stepBranches.find(b => b.default);
        if (defaultBranch?.label?.trim()) return defaultBranch.label.trim();
        return defaultLabel || 'No Match';
    }
    const index = stepBranches.findIndex(b => b.id === branchID);
    const found = stepBranches[index];
    if (found?.label?.trim()) return found.label.trim();
    if (index >= 0) return `Branch ${index + 1}`;
    return defaultLabel || null;
}
